"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DelayFactory = void 0;
const skip_first_delay_1 = require("./skip-first/skip-first.delay");
const always_delay_1 = require("./always/always.delay");
function DelayFactory(options, attempt) {
    const delay = initDelayClass(options);
    delay.setAttemptNumber(attempt);
    return delay;
}
exports.DelayFactory = DelayFactory;
function initDelayClass(options) {
    if (!options.delayFirstAttempt) {
        return new skip_first_delay_1.SkipFirstDelay(options);
    }
    return new always_delay_1.AlwaysDelay(options);
}
